export default function checkIfWafError(error: { status?: number, data: unknown }): false|string {
    const { status, data } = error;
    if (status !== 403 || typeof data !== 'string' || data.indexOf('Error ID: ') === -1) {
        // No WAF error
        return false;
    }

    let response;
    try {
        response = (new DOMParser()).parseFromString(data, 'text/html');
    } catch {
        console.error(
            'WAF Check: Unable to parse ajax response with status code 403 to check for WAF errors. Ignoring silently',
        );

        return false;
    }

    const h1 = response.getElementsByTagName('h1')[0] ?? null;
    if (h1?.innerText?.trim() !== 'Zugriff nicht möglich.') {
        // No WAF error
        return false;
    }

    // Search for WAF error ID and return it if found
    let wafErrorId: false|string = false;
    for (const paragraph of response.getElementsByTagName('p')) {
        const trimmed = paragraph.innerText.trim();
        if (trimmed.startsWith('Error ID: ')) {
            wafErrorId = trimmed.substring(10);
        }
    }

    return wafErrorId;
}
